import { Injectable } from '@angular/core';

@Injectable( {
  providedIn: 'root'
} )
export class EmbeddedTokenService {
  private accessToken: string | null = null;
  private refreshToken: string | null = null;

  getToken(): string | null {
    return this.accessToken;
  }

  getRefreshToken(): string | null {
    return this.refreshToken;
  }

  setTokens( token: string, refreshToken: string ): void {
    this.accessToken = token;
    this.refreshToken = refreshToken;
  }

  clearTokens(): void {
    this.accessToken = null;
    this.refreshToken = null;
  }

  saveToken( token: string ): void {
    this.accessToken = token;
  }

  saveRefreshToken( refreshToken: string ): void {
    this.refreshToken = refreshToken;
  }

  removeToken(): void {
    this.accessToken = null;
  }

  removeRefreshToken(): void {
    this.refreshToken = null;
  }
}